export default "__VITE_ASSET__0ba550ab__"